export function importAll(m) {
	m.keys().forEach(m);
}
